import React, { useEffect } from "react";
import { createRulesPerPage } from './CreateRulesPerPage'; 
import { addEditIcons } from "./AddEditIcons";
import editRadioComps from "./EditRadioComps";
import handleOpenHrefPopUPCss from "./HandleOpenHrefPopUpCss";
import assignImportantRules from "./AssignImportantRules";
import makeComponentsEditable from "./makeComponentsEditable";
import preventRunCommands  from './PreventRunCommands';
import initializeProjectLoader from "./InitializeProjectLoader";
import removeJavascriptOnDeleteComp from "./RemoveJavascriptOnRemoveComp";
import handleNumberOfListItemsPopUp from "./HandleNumberOfListItemsPopUp";
import EditListItemsPerPagePopUp from '../PopUpsValidations/EditListItemsPerPagePopUp';
import loadClassesOnClear from "./LoadClassesOnClear";
import assignValueToRadioComps from "./AssignValueToRadioComps";
import assignSameAnnotationToItemsComp from "./AssignSameAnnotationToItemsComp";
import syncUndoRedoActionsWithJavascript from "./SyncUndoRedoActionsWithJavascript";
import fullscreenMode from "./FullscreenMode";
import handleStoreManager from "./HandleStoreManager";
import handleAddJavascriptOnAddComponent from "./HandleAddJavascriptOnAddComponent";
import catchGrapesJsErrors from './CatchGrapesJsErrors';
import handleCustomFunctions from './HandleCustomFunctions';
import handleAssetManager from "./HandleAssetManager";
import FillLocaleStoragePopUp from "../PopUpsValidations/FillLocaleStoragePopUp";
import handleModals from "./HandleModals";
import handleBlocks from "./HandleBlocks";
import handleSaveAsterisc from "./HandleSaveAsterisc";
import handleBlocksTabPanel from "./HandleBlocksTabPanel";
import addTemplates from "./AddTemplates";

const LoadEditableElements = props => {
  const { editor, selectedPage, selectedProject, setDisplaySpinner, setRunFullScreen, loadInfo, savedPagesPerProject, setSavedPagesPerProject, setEnableBreadcrumb, savedPageClicked } = props;
  const [renderAgain, setRenderAgain] = React.useState(false);
  const [openNumberOfListItemsPopUp, setOpenNumberOfListItemsPopUp] = React.useState(false);
  const [componentId, setComponentId] = React.useState(-1);
  const [openLocaleStoragePop, setOpenLocaleStoragePopUp] = React.useState(false);

  useEffect(() => {
    if (renderAgain === true) {
      setRenderAgain(false);
    }
  }, [renderAgain]);


  useEffect(() => {
    if (
      selectedPage > -1 &&
      selectedProject > -1 &&
      editor.BlockManager !== undefined
    ) {      
      initializeProjectLoader(editor,setDisplaySpinner);
      addEditIcons(editor);
      editRadioComps(editor);
      handleOpenHrefPopUPCss(editor);
      createRulesPerPage(editor);
      addTemplates(editor);
      assignImportantRules(editor);
      makeComponentsEditable(editor);
      preventRunCommands(editor);
      removeJavascriptOnDeleteComp(editor);
      handleNumberOfListItemsPopUp(editor,setOpenNumberOfListItemsPopUp,setComponentId);
      loadClassesOnClear(editor);
      assignValueToRadioComps(editor);
      assignSameAnnotationToItemsComp(editor);
      syncUndoRedoActionsWithJavascript(editor);
      fullscreenMode(editor,setRunFullScreen);
      handleAddJavascriptOnAddComponent(editor);
      catchGrapesJsErrors(editor);
      handleCustomFunctions(editor);
      handleAssetManager(editor, setOpenLocaleStoragePopUp);
      handleModals(editor,setOpenLocaleStoragePopUp);
      handleSaveAsterisc(editor,savedPagesPerProject,setSavedPagesPerProject,selectedPage,selectedProject,setEnableBreadcrumb);
      handleBlocksTabPanel(editor, selectedProject);
    }
  },[selectedProject,selectedPage]);

  useEffect( () => {
    if(editor.BlockManager !== undefined){
      handleBlocks(editor,savedPageClicked);
    }
  },[editor,selectedPage,selectedProject]) 

  useEffect( () => {

    if (
      selectedPage > -1 &&
      selectedProject > -1 &&
      editor.BlockManager !== undefined
    ) {    
      handleStoreManager(editor,selectedProject, selectedPage);
    }
  },[selectedProject, selectedPage, loadInfo])

  return (
  <>
    <EditListItemsPerPagePopUp
      editor={editor}
      openNumberOfListItemsPopUp={openNumberOfListItemsPopUp}
      setOpenNumberOfListItemsPopUp={setOpenNumberOfListItemsPopUp}
      componentId={componentId}
    />
     <FillLocaleStoragePopUp
          openAlert={openLocaleStoragePop}
          setOpenAlert={setOpenLocaleStoragePopUp}
      />
  </>
  );
};

export default LoadEditableElements;
